<template>
  <div class="searchpage-layout-buttons">
    <button
      @click="$emit('changeLayout', 'boxes')"
      class="icon-th"
      :class="{ xselected: layout == 'boxes' }"
    ></button>
    <button
      @click="$emit('changeLayout', 'table')"
      class="icon-list"
      :class="{ xselected: layout == 'table' }"
    ></button>
    <button
      v-if="advancedSearchEnabled"
      @click="$emit('toggleAdvancedSearch', true)"
    >
      Advanced Search
    </button>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, computed, PropType } from "vue";
import { SearchPageProperties } from "@/types/search-page";

const props = defineProps({
  settings: {
    type: Object as PropType<SearchPageProperties>,
    required: true,
  },
  advancedSearchEnabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const layout = computed<string>(() => props?.settings?.layout || "boxes");

const emit = defineEmits<{
  (e: "changeLayout", layout: string): void;
	(e: "toggleAdvancedSearch", flag: boolean): void;
}>();
</script>

<style scoped>
div.searchpage-layout-buttons {
  float: right;
  margin-top: 10px;
}

div.searchpage-layout-buttons button {
  cursor: pointer;
  display: inline-block;
  background: white;
  margin-left: 8px;
  padding: 6px 10px;
  border-radius: 3px;
  font-size: 13px;
  color: black;
  border: 2px solid #dddddd;
}

div.searchpage-layout-buttons button:hover {
  border: 2px solid black;
}

div.searchpage-layout-buttons button.xselected {
  background: black;
  color: white;
  border: 1px solid #000000;
}

@media screen and (max-width: 992px) {
  div.searchpage-layout-buttons {
    display: none;
  }
}
</style>
